import React from 'react';
import c from 'classnames';
import './style.scss';
var Icon = function Icon(_ref) {
  var name = _ref.name,
    _ref$flair = _ref.flair,
    flair = _ref$flair === void 0 ? '' : _ref$flair,
    className = _ref.className;
  var flairPostFix = flair && flair.length > 0 ? '-' : '';
  var classNames = c('Icon', "Icon-".concat(flair).concat(flairPostFix).concat(name), className);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  });
};
export default Icon;